(function () {
  'use strict';

  var FLAG_KEY = 'myao_show_iphone_dialog';
  var TARGET_KEY = 'myao_entry_target_url';

  function getStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      try {
        return window.localStorage;
      } catch (ignored) {
        return null;
      }
    }
  }

  function readFlag() {
    var storage = getStorage();
    if (!storage) return '';
    return storage.getItem(FLAG_KEY) || '';
  }

  function clearFlag() {
    var storage = getStorage();
    if (!storage) return;
    storage.removeItem(FLAG_KEY);
    storage.removeItem(TARGET_KEY);
  }

  function isExplicitIPhone() {
    var ua = navigator.userAgent || '';
    var platform = navigator.platform || '';
    return /\biPhone\b/i.test(ua) || platform === 'iPhone';
  }

  function init() {
    var root = document.querySelector('[data-myao-iphone-dialog]');
    if (!root) return;

    var flag = readFlag();
    var shouldShow = flag === 'manual' || (flag === 'auto' && isExplicitIPhone());
    if (!shouldShow) return;

    clearFlag();
    root.hidden = false;
    document.documentElement.classList.add('myao-iphone-dialog-open');

    function close() {
      root.hidden = true;
      document.documentElement.classList.remove('myao-iphone-dialog-open');
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-myao-iphone-dialog-close]')) {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
